import { Chart, registerables } from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import zoomPlugin from 'chartjs-plugin-zoom'
import 'chartjs-adapter-luxon'

export default defineNuxtPlugin(() => {
  // TODO: utilize tree shaking and only import needed components
  Chart.register(...registerables, annotationPlugin, zoomPlugin)
})
